import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Prismic from 'prismic-javascript';
import styled from 'styled-components';
import MetaTags from 'react-meta-tags';
import { RichText } from 'prismic-reactjs';
import Moment from 'react-moment';
import 'moment/locale/pt-br';
import { DiscussionEmbed } from 'disqus-react';

import Header from '../../components/header';
import Newsletter from '../../components/newsletter';
import Footer from '../../components/footer';
import Related from './related';

import LanguageContext from '../../context/LangContext';

const Breadcrumbs = styled.div`
  background: #fff;
  .wrapper {
    height: 60px;
    span,
    a {
      text-decoration: none;
      color: #40403F;
      font: 14px Montserrat;
      &.back {
        font-weight: 600;
        @media (max-width: 540px) {
          display: none;
        }
        &:before {
          content: ' ';
          background: url(/images/arrow-left.png) center no-repeat;
          width: 15px;
          height: 15px;
          margin-right: 10px;
          display: inline-block;
          background-size: contain;
          vertical-align: middle;
        }
        &:hover {
          text-decoration: underline;
        }
      }
    }
    div {
      flex-grow: 1;
      span,
      a {
        font-weight: 300;
        &:before {
          content: ' > ';
        }
        &:first-child {
          &:before {
            content: '';
          }
        }
      }   
    }
  }
`

const Title = styled.div`
  background: #fff;
  padding: 0 0 40px;
  .wrapper {
    max-width: 780px;
    h1 {
      margin: 0 0 25px;
      font: bold italic 40px 'Times new roman';
    }
    p {
      font-size: 14px;
      line-height: 24px;
      color: #616161;
      margin: 0 0 30px;
    }
    span {
      font: bold 12px Montserrat;
      color: #000;
      a {
        color: #000;
        text-decoration: none;
      }
      span {
        margin: 0 14px;
      }
    }
  }
`

const Container = styled.div`
  background: #DEDEDE;
  padding: 48px 0 0;
  .wrapper {
    max-width: 780px;
    p {
      color: #616161;
      font: 14px/24px Montserrat;
    }
    h1 {
      font: italic bold 28px 'Times New Roman';
    }
    h2 {
      font: 16px Montserrat;
    }
    h3 {
      text-align: center;
      font: italic bold 22px 'Times New Roman';
      &:before {
        content: '"';
      }
      &:after {
        content: '"';
      }
    }
    h4 {
      text-align: center;
      font: italic 16px 'Times New Roman';
      &:before {
        content: '— ';
      }
    }
    h5 {
      font: italic 12px Montserrat;
      margin: -10px 0 32px;
    }
    iframe {
      width: 100%;
      min-height: 50vh;
    }
    img {
      max-width: 100%;
    }
    a {
      text-decoration: underline;
      color: #000000;
    }
    .holder {
      padding-bottom: 20px;
    }
    @media (max-width: 540px) {
      h1 {
        font-size: 1.2em;
      }
      h2 {
        font-size: 0.9em;
      }
      h3 {
        font-size: 0.8em;
      }
    }
    .comments {
      margin: 60px auto 0;
      cursor: pointer;
      max-width: 380px;
      width: 100%;
      background: #F1A857;
      display: flex;
      border-radius: 3px;
      border: 0;
      color: #fff;
      height: 60px;
      align-items: center;
      font-size: 16px;
      padding: 0;
      transition: all 0.3s;
      &:hover {
        background: #E59134;
        .text {
          border-right: 1px solid #CD8226;
        }
      }
      @media (max-width: 1080px) {
        margin: 0 auto;
      }
      .text {
        height: 100%;
        flex-grow: 1;
        border-right: 1px solid #D99440;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .icon {
        display: flex;
        align-items: center;
        min-width: 82px;
        justify-content: center;
        i {
          width: 24px;
          background: url(/images/streamline-icon-conversation-chat@140x140.png) center no-repeat;
          height: 24px;
          background-size: contain;
        }
      }
    }
  }
`

const Spacer = styled.div`
  height: 100px;
  background: #DEDEDE;
`

const apiEndpoint = 'https://guararapes.cdn.prismic.io/api/v2'
const Client = Prismic.client(apiEndpoint);

class BlogIntern extends Component {
  state = {
    content: {},
    uid: '',
    language: '',
    done: false,
    related: [],
    comments: false,
  }

  componentDidMount = () => {
    const { language } = this.context;
    this.setState({language: language});
    this.getContent();
  }

  componentDidUpdate = () => {
    const { language } = this.context;
    if (
      this.props.match.params.uid !== this.state.uid ||
      this.state.language !== language
    ) {
      this.setState({language: language});
      window.scrollTo(0, 0)
      this.getContent();  
    }
  }

  getContent() {
    const { language } = this.context;
    this.setState({uid: this.props.match.params.uid});
    
    const fetchDataCategoria = async (slug) => {
      const response = await Client.query(
        Prismic.Predicates.at('my.categoria_conteudo.uid', slug),
        {lang: language}
      )
      if (response) {
        this.setState({category: response.results[0]});
      }
    }

    const fetchData = async () => {
      const response = await Client.query(
        Prismic.Predicates.at('my.conteudo.uid', this.props.match.params.uid),
        {lang: language}
      )
      if (response) {
        this.setState({content: response.results[0].data, done: true, related: [], category: []});

        if (response.results[0].data.categoria.slug) {
          fetchDataCategoria(response.results[0].data.categoria.slug);
          this.getRelated()
        }
      } else {
        this.props.history.push('/onde-encontrar/compensados');
      }
    }
    fetchData();
  }

  getRelated() {
    const fetchData = async () => {
      const response = await Client.query(
        Prismic.Predicates.at('my.conteudo.categoria', this.state.content.categoria.id),
        { pageSize : 3, orderings : '[my.conteudo.data desc]' }
      )
      if (response) {
        this.setState({related: response.results});
      }
    }
    fetchData();
  }

  toggleComments = () => {
    this.setState({ comments: !this.state.comments });
  }

  render = () => {
    const { language } = this.context;
    let home = ''
    let conteudos = ''
    let voltar = ''
    let comentarios = ''
    switch (language) {
      case 'pt-br':
        conteudos = 'Conteúdos'
        home = 'Início'
        voltar = 'Voltar para todos os posts'
        comentarios = !this.state.comments ? 'Ver Comentários' : 'Fechar comentários';
        break;
      case 'en-us':
        conteudos = 'Contents'
        home = 'Home'
        voltar = 'Back to all posts'
        comentarios = !this.state.comments ? 'View Comments' : 'Close Comments';
        break;
      case 'es-es':
        conteudos = 'Contenidos'
        home = 'Inicio'
        voltar = 'Volver a todas las publicaciones'
        comentarios = !this.state.comments ? 'Ver comentarios' : 'Ocultar comentarios';
        break;
      default:
    }
    return this.state.done && (
      <div id="home">
        <MetaTags>
          <title>{ this.state.content.meta_title }</title>
          <meta id="meta-description" name="description" content={ this.state.content.meta_description } />
          <meta id="og-title" property="og:title" content={ this.state.content.meta_title } />
        </MetaTags>
        <Header />
        <Breadcrumbs>
          <div className="wrapper flex">
            <div>
              <Link to="/">{ home }</Link>
              <Link to="/conteudos">{ conteudos }</Link>
              {
                (this.state.category && this.state.category.data) && (
                  <Link to={ `/conteudos/${this.state.category.uid}` }>{ this.state.category.data.titulo[0].text }</Link>
                )
              }
              <span>{ this.state.content.titulo && this.state.content.titulo[0].text }</span>
            </div>
            <Link to="/conteudos" className="back">{ voltar }</Link>
          </div>
        </Breadcrumbs>
        <Title>
          <div className="wrapper">
            { RichText.render(this.state.content.titulo) }
            { RichText.render(this.state.content.subtitulo) }
            <span>
              {
                (this.state.category && this.state.category.data) && (
                  <Link to={ `/conteudos/${this.state.category.uid}` }>{ this.state.category.data.titulo[0].text }</Link>
                )
              }
              <span>/</span>
              <Moment format={ 'LL' } locale={ language }>
                { this.state.content.data }
              </Moment>
            </span>
          </div>
        </Title>
        <Container>
          <div className="wrapper">
            { RichText.render(this.state.content.conteudo) }
            <div className="holder">
              <button className="comments" onClick={ this.toggleComments }>
                <span className="text">{ comentarios }</span>
                <span className="icon">
                  <i></i>
                </span>
              </button>
            </div>
            {
              this.state.comments && (
                <DiscussionEmbed
                  shortname='example'
                  config={
                    {
                      url: `//guararapes.com.br/conteudo/${this.state.content.guid}`,
                      identifier: this.state.content.guid,
                      title: this.state.content.title,
                      language: 'pt_BR'
                    }
                  }
                />
              )
            }
          </div>
        </Container>
        {
          this.state.related.length > 0 && (
            <Related items={ this.state.related } />
          )
        }
        {
          this.state.related.length === 0 && (
            <Spacer />
          )
        }
        <Newsletter />
        <Footer />
      </div>
    );
  }
}

BlogIntern.propTypes = {
  dispatch: PropTypes.func,
  match: PropTypes.object,
  location: PropTypes.object,
};

BlogIntern.contextType = LanguageContext;

export default BlogIntern;
